import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import levelsSidebarMenu from 'src/examples/SidebarMenu/levels';
import statesSidebarMenu from 'src/examples/SidebarMenu/states';
import sizeMediumSidebarMenu from 'src/examples/SidebarMenu/sizeMedium';
import sizeSmallSidebarMenu from 'src/examples/SidebarMenu/sizeSmall';
import * as React from 'react';
export default {
  graphql,
  ComponentApi,
  CodeView,
  levelsSidebarMenu,
  statesSidebarMenu,
  sizeMediumSidebarMenu,
  sizeSmallSidebarMenu,
  React
};